<div class="container">
  <div class="title">
    <h2>OTA Portal - Login</h2>
  </div>

  @if (flags != []) {
    @for (flag of flags; track flag) {
      <div style="margin-bottom: 0.5rem">
        <p-message icon="pi pi-info-circle" severity="info" size="small" [text]="flagLabelMapping[flag]" />
      </div>
    }
    <p-divider />
  }

  <form #credentialsForm [formGroup]="formGroup" pForm (ngSubmit)="startSession($event)">
    <div>
      <p class="pt-0-5">
        <p-input-group class="field">
          <p-inputgroup-addon>
            <i class="pi pi-user"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input 
              required="true" 
              pInputText 
              formControlName="username" 
              type="text" 
              id="username" 
            />
            <label for="username">Username</label>
          </p-floatlabel>
        </p-input-group>
      </p>
    </div>

    <div>
      <p class="pt-0-5">
        <p-input-group class="field">
          <p-inputgroup-addon>
            <i class="pi pi-lock"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input 
              required="true" 
              pInputText 
              formControlName="password" 
              type="password" 
              id="password" 
            />
            <label for="password">Password</label>
          </p-floatlabel>
        </p-input-group>
      </p>
    </div>

    <p-divider type="solid" dir="ltr" style="margin: 1.5rem 0;" />

    <div class="signup-button-container-upper">
      <p-button
        type="submit"
        fluid="true"
        label="Sign in"
        [loading]="loading"
      />
    </div>

    <div class="signup-button-container">
      <p-button
        label="Create account"
        severity="secondary"
        [outlined]="true"
        styleClass="signup-button"
        fluid="true"
        (onClick)="goToSignup()"
      />
    </div>

    <div class="forgot-password">
      <a routerLink="/password-reset">Forgot password?</a>
    </div>
    @if (errorMessage !== null) {
      <div class="error-message-box">
        <strong>Error</strong>
        <p>
          {{ errorMessage }}
        </p>
      </div>
    }
  </form>
</div>
